import type { ChatSummary } from '../../../types';
import type { TabType, TabDefinition } from '../types';

/**
 * Filter chats based on active tab
 * Pure function for filtering
 * Excludes chats with IDs starting with 'ai-form-' from the sidebar
 */
export const filterChatsByTab = (chats: ChatSummary[], activeTab: TabType): ChatSummary[] => {
  // Filter out chats with IDs starting with 'ai-form-'
  const visibleChats = chats.filter((chat) => !chat.id.startsWith('ai-form-'));
  
  if (activeTab === 'all') return visibleChats;
  if (activeTab === 'active') return visibleChats.filter((chat) => chat.status === 'active');
  if (activeTab === 'archived') return visibleChats.filter((chat) => chat.status === 'archived');
  return visibleChats;
};

/**
 * Count chats by status
 * Pure functions for counting
 * Excludes chats with IDs starting with 'ai-form-'
 */
export const countChatsByStatus = (chats: ChatSummary[], status: 'active' | 'archived'): number => {
  return chats
    .filter((c) => !c.id.startsWith('ai-form-'))
    .filter((c) => c.status === status).length;
};

/**
 * Create tab definitions with counts
 * Pure function for tab data creation
 * Excludes chats with IDs starting with 'ai-form-'
 */
export const createTabDefinitions = (
  chats: ChatSummary[]
): TabDefinition[] => {
  const visibleChats = chats.filter((chat) => !chat.id.startsWith('ai-form-'));
  const activeChatCount = countChatsByStatus(visibleChats, 'active');
  const archivedChatCount = countChatsByStatus(visibleChats, 'archived');

  return [
    { id: 'active', label: 'Active Chats', count: activeChatCount },
    { id: 'archived', label: 'Archived Chats', count: archivedChatCount },
    { id: 'all', label: 'All Chats', count: visibleChats.length },
  ];
};
